export default {
  header: {
    products: 'Products',
    events: 'Events',
    exhibitor: 'Companies',
    societe: 'Company',
    users: 'Users',
    connector_admin: 'Connector Admin',
    connector: 'Connector',
    company_settings: 'Company Settings',
    sign_out: 'Sign Out',
    categories: 'Categories',
    subcategories: 'SubCategories',
    universes: 'Universes',
  },
  eventList: {
    question: 'Quizz',
    exhibitor: 'Exhibitors',
    events: 'Event information',
    offers: 'Offers',
    forms: 'Forms',
    offerEditor: 'Offer Editor',
    websiteEditor: 'Website Editor',
    floorMap: 'Floor Map',
    pdfEditor: 'PDF Editor',
    exhibitorsWebsite: 'Exhibitors Website',
  },
};
